module.exports = __webpack_public_path__ + "static/media/Light_Divider@3x.94546a6d.png";